export default "__VITE_ASSET__425a6516__"